module.exports = __webpack_public_path__ + "img/1F623.986c1944.svg";